import { render, staticRenderFns } from "./ScreenSecond.vue?vue&type=template&id=0a98fe76&scoped=true&"
import script from "./ScreenSecond.vue?vue&type=script&lang=js&"
export * from "./ScreenSecond.vue?vue&type=script&lang=js&"
import style0 from "./ScreenSecond.vue?vue&type=style&index=0&id=0a98fe76&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a98fe76",
  null
  
)

export default component.exports